import { SelectionType } from "src/js/stores/map/store";
import { DesignationsSelectionSidebarConnected } from "react-migration/domains/constraints/designation/components/Designations/DesignationsSelectionSidebar";
import { LayerTypeSelectionSidebarProps } from "../../types";

export function TrafficSelectionSidebar(props: LayerTypeSelectionSidebarProps) {
  return <DesignationsSelectionSidebarConnected {...props} selectionType={SelectionType.TRAFFIC} />;
}
